import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import {TaskStatusIds} from './../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function EPEQRTasksDocSignOffCount(state = initialState.epeqrtasksdocsignoffcounts, action) {
	switch (action.type) {
		case types.GET_EP_EQR_TASKS_SIGN_OFF_COUNT: {
			let taskList = action.response;
			if (taskList) {
				let taskEPEQRApprovalDetails = taskList.taskEPEQRApprovalDetails;
				if (taskList.taskGroups && action.includeTaskList) {
					_.forEach(taskEPEQRApprovalDetails, (grp) => {
						grp.tasks = taskList.taskGroups.find((x) => x.id === grp.taskGroupID)?.tasks;
					});
				}
				if (action.key) {
					let updatedData = {...state};
					updatedData[action.key] = taskList.totalCount;
					return updatedData;
				}
				return taskEPEQRApprovalDetails;
			}
			return state;
		}

		case types.CLEAR_EP_EQR_TASKS_SIGN_OFF_COUNT: {
			return [];
		}

		default:
			return state;
	}
}
